import { render, staticRenderFns } from "./right-panel.vue?vue&type=template&id=167546d0&"
import script from "./right-panel.vue?vue&type=script&lang=js&"
export * from "./right-panel.vue?vue&type=script&lang=js&"
import style0 from "./right-panel.vue?vue&type=style&index=0&id=167546d0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/galexp/development/web/educraft-vue-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167546d0')) {
      api.createRecord('167546d0', component.options)
    } else {
      api.reload('167546d0', component.options)
    }
    module.hot.accept("./right-panel.vue?vue&type=template&id=167546d0&", function () {
      api.rerender('167546d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/right-panel.vue"
export default component.exports